import React, { useState } from "react";
import axios from "axios";
import useAdminGuard from "../hooks/useAdminGuard";
import {Link} from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const PdfUpload = () => {
  useAdminGuard(); //  관리자만 접근
  const [selectedFile, setSelectedFile] = useState(null);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!selectedFile) return setMsg("파일을 선택하세요!");

    setLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const res = await axios.post(`${API_BASE_URL}/upload-pdf`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMsg(res.data.message);
      setSelectedFile(null);
    } catch (err) {
      setMsg("업로드 실패: " + (err?.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 text-white bg-gray-900 min-h-screen">
      <Link
        to="/admin"
        className="px-4 py-2 text-sm font-semibold bg-purple-500 text-white rounded-full"
      >
        관리자페이지
      </Link>
      <div className="w-full max-w-xs sm:max-w-md mx-auto p-4 bg-white dark:bg-gray-800 rounded shadow text-gray-800 dark:text-white mt-8">
        <h2 className="mb-2 font-bold text-center">PDF 업로드</h2>
        <form onSubmit={handleUpload} className="flex flex-col gap-2">
          <input type="file" accept=".pdf" onChange={handleFileChange} className="mb-2" />
          <button
            type="submit"
            disabled={loading}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:bg-gray-400"
          >
            {loading ? "업로드 중..." : "업로드"}
          </button>
        </form>
        {msg && <div className="mt-2 text-blue-600 text-center">{msg}</div>}
      </div>
    </div>
  );
};

export default PdfUpload;
